import { useMemo, useState } from 'react'

import { Box, Button, Grid } from '@mui/material'

import { CardTitle, FplDataGrid, IGridColumn } from 'components/common'
import { GET_PAGED_SUPPLIERS_BOOKING_ALLOCATED_DRIVERS } from 'graphql/queries'

import { AllocateDrivers } from './AllocateDrivers'

interface IAllocatedDriversProps {
  bookingId?: string
}

export const AllocatedDrivers = (props: IAllocatedDriversProps) => {
  const { bookingId } = props

  const [openAllocateDriverDialog, setOpenAllocateDriverDialog] = useState<boolean>(false)

  const queryVariables = useMemo(() => ({ bookingId: Number(bookingId) }), [bookingId])

  const columns: IGridColumn[] = [
    {
      field: 'primaryDriverName',
      headerName: 'Company',
      minWidth: 150,
      flex: 1,
      sortable: false,
      valueGetter: ({ row }) => row?.driver.primaryDriverName,
    },
    {
      field: 'driver',
      headerName: 'Driver',
      minWidth: 150,
      flex: 1,
      sortable: false,
      valueGetter: ({ value }) => value?.name,
    },
    {
      field: 'charge',
      headerName: 'Charge',
      minWidth: 100,
      sortable: false,
      type: 'number',
    },
    {
      field: 'extraPayment',
      headerName: 'Extra payment',
      minWidth: 100,
      sortable: false,
      type: 'number',
    },
    {
      field: 'allocationStatus',
      headerName: 'Allocation status',
      minWidth: 100,
      sortable: false,
      type: 'string',
    },
    {
      field: 'vehicle',
      headerName: 'Vehicle',
      minWidth: 150,
      flex: 0.5,
      sortable: false,
      valueGetter: ({ value }) => value?.vehicleType.name || 'N/A',
    },
    { field: 'createdAt', headerName: 'Created At', type: 'string' },
  ]

  const handleAllocate = () => setOpenAllocateDriverDialog(true)

  const handleCloseAllocateDriversDialog = () => {
    setOpenAllocateDriverDialog(false)
  }

  return (
    <>
      <CardTitle>Company/Vehicle Details</CardTitle>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FplDataGrid
            isRowSelectable={() => false}
            skipQuery={!bookingId}
            query={GET_PAGED_SUPPLIERS_BOOKING_ALLOCATED_DRIVERS}
            queryVariables={queryVariables}
            entityName='pagedSupplierBookingAllocatedDrivers'
            columns={columns}
            defaultOrder={{ field: 'createdAt', sort: 'desc' }}
            pageOptions={{ pageSize: 100, rowsPerPage: [100] }}
            hideFooter
            hideToolbar
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box display='flex' justifyContent='flex-start'>
            <Button onClick={handleAllocate} variant='contained' color='grey' disabled={!bookingId}>
              Allocate
            </Button>
          </Box>
        </Grid>
      </Grid>

      {openAllocateDriverDialog && (
        <AllocateDrivers
          bookingId={bookingId}
          openDialog={openAllocateDriverDialog}
          onCloseDialog={handleCloseAllocateDriversDialog}
        />
      )}
    </>
  )
}
